
import { i18nText } from '@/locales';

import { Component, Vue, Watch } from 'vue-property-decorator';
import { Alert, Table } from 'ant-design-vue';
import Api from '@/repository/api';
import qs from 'qs';

@Component({ components: { 'a-alert': Alert, 'a-table': Table } })
export default class VisitHistory extends Vue {
  rows: any[] = [];
  loading = false;
  error = '';
  page = 1;
  total = 0;
  columns = [
    { title: i18nText("Когда"), dataIndex: 'created_at' },
    { title: i18nText("Действие"), dataIndex: 'type', scopedSlots: { customRender: 'operation' } },
    { title: i18nText("Статус"), key: 'status', scopedSlots: { customRender: 'status' } },
    { title: i18nText("Кто"), key: 'author', scopedSlots: { customRender: 'author' } },
    { title: i18nText("Комментарий"), dataIndex: 'comment' },
  ];
  operation(type: string): string {
    return ({ create: i18nText("Создание"), update: i18nText("Изменение"), cancel: i18nText("Отмена") } as Record<string, string>)[type] || type || i18nText("Изменение");
  }
  @Watch('$route.params.id', { immediate: true })
  async visitChanged(): Promise<void> { await this.load(1); }
  async load(page = 1): Promise<void> {
    this.loading = true;
    this.error = '';
    try {
      const response = await Api.get('/visits/history', { params: {
        filter: { visit_id: this.$route.params.id }, sort: 'id', by: 'desc', skip: (page - 1) * 10, limit: 10,
      }, paramsSerializer: params => qs.stringify(params) });
      if (response.data.status === false) throw new Error(response.data.response);
      this.rows = response.data.data;
      this.total = response.data.total;
      this.page = page;
    } catch (e) {
      this.rows = [];
      this.error = i18nText("Не удалось загрузить историю записи");
    } finally { this.loading = false; }
  }
}
